import React, { useState, useEffect } from 'react';
import { Maximize, UploadCloud, Expand } from 'lucide-react';
import DocumentPreview from '../../Create-Investment/documentpreview';
import { useDispatch, useSelector } from 'react-redux';
import { clearCurrentStep } from '../../../Redux/store/onboardingFormSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../../Utils/toastContext';
import TermsModal from '../../../Components/TermPopup/term-popup';
import { useLocation } from 'react-router-dom';

const ReviewSubmit = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [eddResponse, setEddResponse] = useState([]);
  const { shareholderId, shareholderType, userType, shareholderName } =
    useParams();

  const stepStatus = useSelector((state) => state.form.stepStatusShareholder);
  const [loading, setLoading] = useState(false);
  const formData = useSelector((state) => state.form.formData);
  const [firstName, setFirstName] = useState('');
  const [profilePic, setProfilePic] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [otherActivity, setOtherActivity] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [fullName, setFullName] = useState('');
  const [formerNames, setFormerNames] = useState('');
  const [dob, setDob] = useState('');
  const [redAddress, setRedAddress] = useState('');
  const [ownership, setOwnership] = useState('');
  const [applicantCountryText, setApplicantCountryText] = useState('');
  const [clientNo, setClientNo] = useState('CM0013189P');
  const [jointAccountID, setJointAccountID] = useState('');
  const [expectedAmount, setExpectedAmount] = useState('');
  const [investmentCurrency, setInvestmentCurrency] = useState('');
  const [signatory, setSignatory] = useState('yes');
  const [thirdPartySign, setThirdPartySign] = useState('yes');
  const [jointAccountName, setJointAccountName] = useState('');
  const [fileAttorney, setFileAttorney] = useState(null);
  const [taxResidentCountry, setTaxResidentCountry] = useState(1);
  const [taxResidentCountryText, setTaxResidentCountryText] = useState('US');
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState('');
  const [nonResCountry, setNonResCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState('');
  const [socialSecurityNumber, setSocialSecurityNumber] = useState('');
  const [taxId, setTaxId] = useState('');
  const [abn, setAbn] = useState('');
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState('');
  const [businessAddress, setBusinessAddress] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [businessActivity, setBusinessActivity] = useState('smaple text');
  const [businessActivityText, setBusinessActivityText] =
    useState('smaple text');
  const [fundSource, setFundSource] = useState('');
  const [transactionNature, setTransactionNature] = useState('');
  const [image, setImage] = useState('/avatar.svg');
  const [fullscreen, setFullscreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmSubmit, setIsConfirmSubmit] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState('');
  const [fileProof, setFileProof] = useState(null);
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [filePurpose, setFilePurpose] = useState('');
  const [accountPurpose, setAccountPurpose] = useState('');
  const [accountType, setAccountType] = useState(null);
  const [documentNumberSecond, setDocumentNumberSecond] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [cardNumberSecond, setCardNumberSecond] = useState('');

  const [countryCode, setCountryCode] = useState('');
  const [stateId, setStateId] = useState('');
  const [countryCodeFirst, setCountryCodeFirst] = useState('');
  const [stateIdFirst, setStateIdFirst] = useState('');
  const [countryCodeSecond, setCountryCodeSecond] = useState('');
  const [stateIdSecond, setStateIdSecond] = useState('');

  const secondheaders = [
    '',
    'First Name',
    'Last Name',
    'Date Of Birth',
    'Email Address',
    'Mobile Number',
    'Account Type',
  ];
  const secondheadersWithAddress = [
    '',
    'First Name',
    'Last Name',
    'Date Of Birth',
    'Email Address',
    'Mobile Number',
    'Residential Address',
    'Account Type',
  ];
  const [bankdata, setBankdata] = useState([]);
  const [accountCount, setAccountCount] = useState(7);
  const [photoIdText, setPhotoIdText] = useState('');
  const [nonphotoIdText, setNonPhotoIdText] = useState('');
  const [nonphotoId, setNonPhotoId] = useState(null);
  const [photoId, setphotoId] = useState(1);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [expiryDate, setExpiryDate] = useState('02/12/2026');
  const [expiryDateSecond, setExpiryDateSecond] = useState('');
  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState('');
  const [photoIdSecondText, setphotoIdSecondText] = useState('');
  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [documentNumber, setDocumentNumber] = useState('');

  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState('');
  const [fileCV, setFileCV] = useState(null);
  const [webLink, setWebLink] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [isConfirmVerify, setIsConfirmVerify] = useState(false);

  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (formData) {
      dispatch(clearCurrentStep());
    }
  }, [formData]);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/stakeholder/individual/review-submit/preview/${shareholderId}`,
      );

      if (response.status == 200) {
        //Personal information
        setProfilePic(response.data.personal_information.profile_picture_file);
        setAccountType(response.data.personal_information.account_type);
        setFullName(
          response.data.personal_information.first_name +
            ' ' +
            response.data.personal_information.last_name,
        );
        setFormerNames(response.data.personal_information.former_names);
        const date = new Date(response.data.personal_information.date_of_birth);
        const formattedDate = date.toLocaleDateString('en-GB');
        setDob(formattedDate);
        setRedAddress(
          response.data.personal_information.address.google_address,
        );
        setApplicantCountryText(
          response.data.personal_information.applicant_country.name,
        );
        setApplicantCountry(
          response.data.personal_information.applicant_country.id,
        );
        //Upload proof
        setImage(response.data.liveness_proof.file);
        // Upload docs
        if (response.data.personal_information.applicant_country.id == 14) {
          setphotoId(
            response.data.proof_document.photographic_documents[0].document_type
              .id,
          );
          setPhotoIdText(
            response.data.proof_document.photographic_documents[0]
              .document_type_name,
          );
          setExpiryDate(
            response.data.proof_document.photographic_documents[0].expiry_date.split(
              'T',
            )[0],
          );
          setDocumentNumber(
            response.data.proof_document.photographic_documents[0]
              .document_number,
          );
          setCardNumber(
            response.data.proof_document.photographic_documents[0]?.card_number,
          );
          setCountryCode(
            response.data.proof_document.photographic_documents[0]
              .country_of_issue,
          );
          if (
            response.data.proof_document.photographic_documents[0]
              .country_of_issue.id == 14
          ) {
            setStateId(
              response.data.proof_document.photographic_documents[0]
                .state_of_issue.name,
            );
          }
          if (
            response.data.proof_document.photographic_documents[0].document_type
              .id != 2
          ) {
            setFilePhotographicId(
              response.data.proof_document.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_document.photographic_documents[0].document_type
              .id == 2
          ) {
            setFileDriverLinsenceFront(
              response.data.proof_document.photographic_documents[0].file,
            );
            setFileDriverLinsenceBack(
              response.data.proof_document.photographic_documents[0].back_file,
            );
          }
        }

        if (response.data.personal_information.applicant_country.id != 14) {
          setphotoIdFirst(
            response.data.proof_document.photographic_documents[0].document_type
              .id,
          );
          setphotoIdFirstText(
            response.data.proof_document.photographic_documents[0]
              .document_type_name,
          );
          setCountryCodeFirst(
            response.data.proof_document.photographic_documents[0]
              .country_of_issue,
          );
          if (
            response.data.proof_document.photographic_documents[0]
              .country_of_issue.id == 14
          ) {
            setStateIdFirst(
              response.data.proof_document.photographic_documents[0]
                .state_of_issue.name,
            );
          }
          if (response.data.proof_document.photographic_documents[1]) {
            setphotoIdSecond(
              response.data.proof_document.photographic_documents[1]
                .document_type.id,
            );
            setphotoIdSecondText(
              response.data.proof_document.photographic_documents[1]
                .document_type_name,
            );
            setDocumentNumberSecond(
              response.data.proof_document.photographic_documents[1]
                .document_number,
            );
            setCardNumberSecond(
              response.data.proof_document.photographic_documents[1]
                ?.card_number,
            );
            setExpiryDateSecond(
              response.data.proof_document.photographic_documents[1].expiry_date.split(
                'T',
              )[0],
            );
            setCountryCodeSecond(
              response.data.proof_document.photographic_documents[1]
                .country_of_issue,
            );
            if (
              response.data.proof_document.photographic_documents[1]
                .country_of_issue.id == 14
            ) {
              setStateIdSecond(
                response.data.proof_document.photographic_documents[1]
                  .state_of_issue.name,
              );
            }
          }

          setDocumentNumber(
            response.data.proof_document.photographic_documents[0]
              .document_number,
          );
          setCardNumber(
            response.data.proof_document.photographic_documents[0]?.card_number,
          );
          setExpiryDate(
            response.data.proof_document.photographic_documents[0].expiry_date.split(
              'T',
            )[0],
          );

          if (
            response.data.proof_document.photographic_documents[0].document_type
              .id != 2
          ) {
            setfilePhotographicIdFirst(
              response.data.proof_document.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_document.photographic_documents[0].document_type
              .id == 2
          ) {
            setFileDriverLinsenceFrontFirst(
              response.data.proof_document.photographic_documents[0].file,
            );
            setFileDriverLinsenceBackFirst(
              response.data.proof_document.photographic_documents[0].back_file,
            );
          }
          if (
            response.data.proof_document.photographic_documents[1] &&
            response.data.proof_document.photographic_documents[1].document_type
              .id != 2
          ) {
            setfilePhotographicIdSecond(
              response.data.proof_document.photographic_documents[1].file,
            );
          }
          if (
            response.data.proof_document.photographic_documents[1] &&
            response.data.proof_document.photographic_documents[1].document_type
              .id == 2
          ) {
            setFileDriverLinsenceFrontSecond(
              response.data.proof_document.photographic_documents[1].file,
            );
            setFileDriverLinsenceBackSecond(
              response.data.proof_document.photographic_documents[1].back_file,
            );
          }
        }
        setNonPhotoId(response.data.proof_document.non_photogenic_id_type);
        setNonPhotoIdText(
          response.data.proof_document.non_photogenic_id_type_name,
        );
        setfileNonPhotographicId(
          response.data.proof_document.non_photogenic_file,
        );
        setPersonalDataId(response.data.proof_document.personal_details_type);
        setPersonalDataIdText(
          response.data.proof_document.personal_details_type_name,
        );
        if (response.data.proof_document.cv_file) {
          setFileCV(response.data.proof_document.cv_file);
        }
        setWebLink(response.data.proof_document.website_link);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  const submitApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/stakeholder/individual/review-submit/submit/${shareholderId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: 'success' };
        navigate(location.state?.from || '/onboarding');
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/customer/edd/${shareholderId}/responses`,
      );
      if (response.status == 200) {
        setEddResponse(response.data);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    getDetails();
  }, [shareholderId]);
  useEffect(() => {
    getEddResponses();
  }, [shareholderId]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[3].status == 'IN_REVIEW' ||
            stepStatus[3].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                Your application is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img
                  src="/profile-circle-black.svg"
                  alt="User Avatar"
                  className="h-6 w-6"
                />
                <h1 className="text-xl font-medium">Personal Information</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(1);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="bg-white border-b pb-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Profile Picture
                  </label>
                  <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                    <img
                      src={profilePic?.presigned_url}
                      alt={`${firstName}`}
                      className="w-20 h-20 rounded-full object-cover"
                    />
                  </div>
                  {/* <label
                    htmlFor="advisorRefNumber"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Advisor Ref No
                  </label>
                  <span>{advisorRefNumber}</span> */}
                  <label
                    htmlFor="TypeOfCustomer"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Type Of Individual Customer
                  </label>
                  <span>Individual</span>
                  {applicantCountry == 233 && (
                    <>
                      <label
                        htmlFor="TypeOfCustomer"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Social Security Number
                      </label>
                      <span>{socialSecurityNumber}</span>
                    </>
                  )}
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="fullName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Full Name
                  </label>
                  <span>{fullName}</span>
                  <label
                    htmlFor="formerNames"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Customer's Former Name(s)
                  </label>
                  <span>{formerNames}</span>
                  <label
                    htmlFor="dob"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Date of Birth
                  </label>
                  <span>{dob}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <label
                    htmlFor="redAddress"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Residential Address
                  </label>
                  <span>{redAddress}</span>
                  <label
                    htmlFor="redAddress"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Applicant's Country
                  </label>
                  <span>{applicantCountryText}</span>
                </div>
              </div>
            </div>
          </div>
          {isModalOpen && currentDocument && (
            <DocumentPreview
              fileUrl={currentDocument.presigned_url}
              fileName={currentDocument.file_name}
              onClose={() => setIsModalOpen(false)}
            />
          )}
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/camera.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Prove Its You</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(3);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              <div className="flex flex-col px-4">
                <div>
                  <span className="text-sm text-[#A6A6A6]">Photo Upload</span>

                  {image && image.presigned_url && (
                    <div className="mt-2 relative w-full max-w-[240px] h-40  rounded-md overflow-hidden">
                      {/* Uploaded Image */}
                      <img
                        src={image.presigned_url}
                        alt="Uploaded"
                        className="w-full h-full object-cover"
                      />

                      {/* Fullscreen Button */}
                      <button
                        onClick={() => setFullscreen(true)}
                        className="absolute top-2 right-2 "
                      >
                        <img
                          src="/show-full.svg"
                          alt="Full Screen"
                          className="w-5 h-5 text-white"
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image.presigned_url}
                    alt="Fullscreen"
                    className="max-w-full max-h-full object-contain rounded-md shadow-lg"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(6);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 pt-2">
              {/* first column */}
              <div className="flex flex-col pr-4 sm:border-r-0 md:border-r border-gray-300">
                {applicantCountry == 14 && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Photographic ID
                      </label>
                    </div>
                    <span>{photoIdText}</span>

                    {(photoId == 1 || photoId == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoId == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Copy of Passport
                            </label>
                          )}
                          {photoId == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                            </label>
                          )}
                        </div>
                        {photoId == 1 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {photoId == 3 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {filePhotographicId && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicId);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicId.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoId == 2 && (
                      <>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumber}</span>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Card Number
                        </label>
                        <span>{cardNumber}</span>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Front)
                          </label>
                        </div>
                        {fileDriverLinsenceFront && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFront);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFront.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBack && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBack);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBack.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{' '}
                    </div>
                    <div className="mt-2">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Country where issued
                        </label>
                      </div>
                      <span>{countryCode.name}</span>
                    </div>
                    {countryCode.id == 14 && (
                      <div className="mt-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            State or Territory in Australia
                          </label>
                        </div>
                        <span>{stateId}</span>
                      </div>
                    )}
                  </>
                )}
                {applicantCountry != 14 && (
                  <>
                    {/* first photo id */}
                    <div className="">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Select First Photographic ID
                      </label>
                      <span>{photoIdFirstText}</span>
                    </div>
                    {(photoIdFirst == 1 || photoIdFirst == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdFirst == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Notarised Foreign Government Issued
                              Passport
                            </label>
                          )}
                          {photoIdFirst == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                            </label>
                          )}
                        </div>
                        {photoIdFirst == 1 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {photoIdFirst == 3 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {filePhotographicIdFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicIdFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicIdFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoIdFirst == 2 && (
                      <>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumber}</span>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Card Number
                        </label>
                        <span>{cardNumber}</span>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Front)
                          </label>
                        </div>
                        {fileDriverLinsenceFrontFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFrontFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFrontFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBackFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBackFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBackFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                    <div className="mt-2">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Country where issued
                        </label>
                      </div>
                      <span>{countryCodeFirst.name}</span>
                    </div>
                    {countryCodeFirst.id == 14 && (
                      <div className="mt-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            State or Territory in Australia
                          </label>
                        </div>
                        <span>{stateIdFirst}</span>
                      </div>
                    )}
                    {/* second photo id */}
                    <div className="">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Select Second Photographic ID
                      </label>
                      <span>{photoIdSecondText}</span>
                    </div>
                    {(photoIdSecond == 1 || photoIdSecond == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdSecond == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Notarised Foreign Government Issued
                              Passport
                            </label>
                          )}
                          {photoIdSecond == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                            </label>
                          )}
                        </div>
                        {photoIdSecond == 1 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumberSecond}</span>
                          </>
                        )}
                        {photoIdSecond == 3 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumberSecond}</span>
                          </>
                        )}
                        {filePhotographicIdSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicIdSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicIdSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoIdSecond == 2 && (
                      <>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumberSecond}</span>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Card Number
                        </label>
                        <span>{cardNumberSecond}</span>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Front)
                          </label>
                        </div>
                        {fileDriverLinsenceFrontSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFrontSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFrontSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBackSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBackSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBackSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDateSecond}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{' '}
                    </div>
                    <div className="mt-2">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Country where issued
                        </label>
                      </div>
                      <span>{countryCodeSecond.name}</span>
                    </div>
                    {countryCodeSecond.id == 14 && (
                      <div className="mt-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            State or Territory in Australia
                          </label>
                        </div>
                        <span>{stateIdSecond}</span>
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 sm:border-r-0 md:border-r border-gray-300">
                <label
                  htmlFor="investmentType"
                  className="text-sm text-labelColour  whitespace-normal break-words block"
                >
                  Non Photographic ID
                </label>
                <span>{nonphotoIdText}</span>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="investmentType"
                    className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                  >
                    Upload Document
                  </label>
                </div>
                {fileNonPhotographicId && (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(fileNonPhotographicId);
                    }}
                    className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                  >
                    <div className="flex-col flex">
                      <span className="text-black underline">
                        {fileNonPhotographicId.file_name}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4"></div>
            </div>
          </div>
        </div>
      </div>
      {isConfirmVerify && (
        <TermsModal
          onClose={() => setIsConfirmVerify(false)}
          onConfirm={() => {
            setIsConfirmVerify(false);
            setLoading(true);
            handleSubmit();
            // additional logic here
          }}
        />
      )}
      {eddResponse &&
        ((eddResponse?.pending?.length || 0) > 0 ||
          (eddResponse?.completed?.length || 0) > 0) && (
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-center w-full mt-2 md:mt-0">
              <div className="flex items-center space-x-2 border rounded-xl w-full px-3 py-1.5 bg-yellow-50 border-yellow-300">
                <p className="text-xs text-black">
                  Your enhanced due diligence questionnaire
                </p>

                <button
                  onClick={() => {
                    const path = `/edd-stakeholder/${shareholderId}/${shareholderType}/shareholder/${false}/${shareholderName}`;

                    let redirectState = {
                      path,
                      state: {
                        from: location.pathname,
                        historyStack: [
                          ...(location.state?.historyStack || []),
                          location.pathname,
                        ],
                      },
                    };

                    sessionStorage.setItem(
                      'redirectAfterLogin',
                      JSON.stringify(redirectState),
                    );

                    navigate(path, {
                      state: redirectState.state,
                    });
                  }}
                  className="bg-black text-white text-xs rounded-full px-3 py-1 font-medium"
                >
                  View
                </button>
              </div>
            </div>
          </div>
        )}
      {stepStatus[3] &&
        stepStatus[3].status !== 'COMPLETED' &&
        stepStatus[3].status !== 'APPROVED' &&
        stepStatus[3].status !== 'IN_REVIEW' && (
          <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
                className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Submit</span>
              </button>
            </div>
          </footer>
        )}
      {isConfirmSubmit && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <div className="flex justify-center items-center mb-4">
              <div className="flex items-center justify-center">
                <img
                  src="/tick-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 className="text-lg font-medium mb-2">Hi {firstName}!</h2>
            <h2 className="text-md font-medium mb-2">
              Individual Application Form has been Submitted Successfully{' '}
            </h2>
            <p className="text-sm text-black mb-4">
              Caprock team will evaluate your application and get back to you
              shortly.
            </p>
            <p className="text-sm text-black mb-4">Thank You. </p>

            <div className="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmSubmit(false);
                  navigate('/login');
                }}
                className="px-6 py-2 bg-[#375AE7] text-white rounded-full font-medium hover:bg-gray-800"
              >
                Back To Login
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewSubmit;
